import React from 'react'
import {cn} from '../../../lib/utils'

export interface IconProps {
    className?: string
    'aria-label'?: string
}

export const BaseIcon: React.FC<IconProps & { children: React.ReactNode }> = ({
    className = 'w-5 h-5',
    'aria-label': ariaLabel,
    children
}) => (
    <svg
        className={cn(className)}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden={!ariaLabel}
        aria-label={ariaLabel}
    >
        {children}
    </svg>
)
